import React from 'react'
import {
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import TechToolsService from './../../shared/TechTools.service'
import { Subscription } from 'rxjs'

import './DeniedAccessModal.scss'

class DeniedAccessModal extends React.Component {
  state = {
    isOpen: false,
    title: '',
    body: <></>,
  }

  #_subscriptions$ = new Subscription()

  #upgrade = () => {
    window.location = '/account-billinginfo'
  }

  #toggleDenialModal = denial => {
    if (!denial || denial === null) {
      if (this.state.isOpen) this.setState({ isOpen: false })
      return
    }

    const getFeature = () => {
      if (denial?.tool_title && denial?.tool_subtitle)
        return (
          <>
            {denial?.tool_title}
            <br />
            {denial?.tool_subtitle}
          </>
        )
      return <>{denial?.tool_title}</>
    }

    this.setState({
      isOpen: true,
      title: denial.denial,
      body: (
        <>
          <table>
            <tbody>
              <tr>
                <td valign='middle' colSpan='2'>
                  We&apos;re sorry, but your account does not provide access to the following feature:
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <table>
            <tbody>
              <tr>
                <td valign='middle'>
                  <div className='h5'>
                    <MDBIcon icon='exclamation-triangle' className='text-danger' />
                  </div>
                </td>
                <td valign='middle'>&nbsp;{getFeature()}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <table>
            <tbody>
              <tr>
                <td valign='middle' colSpan='2'>
                  <MDBBtn type='button' color='default' onClick={() => this.#upgrade()} className='upgrade-btn'>
                    Click Here to see Agent Package Benefits & upgrade your account!
                  </MDBBtn>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ),
    })
  }

  #closeModal = () => TechToolsService.resetAccessDenied()

  componentDidMount() {
    this.#_subscriptions$.add(
      TechToolsService.getDeniedAccessEvent().subscribe(denial => this.#toggleDenialModal(denial))
    )
  }

  componentWillUnmount() {
    this.#_subscriptions$.unsubscribe()
  }

  render() {
    return (
      <>
        <MDBModal
          id='DeniedAccessModal'
          open={this.state.isOpen}
          tabIndex='-1'
          onClose={this.#closeModal}
          className='error-modal'
        >
          <MDBModalDialog size='lg'>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{this.state.title}!</MDBModalTitle>
                <MDBBtn type='button' className='btn-close' color='none' onClick={this.#closeModal}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                {
                  <>
                    <div className='modal-message'>{this.state.body}</div>
                  </>
                }
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn type='button' color='default' className='btn-block' onClick={this.#closeModal}>
                  CLOSE
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    )
  }
}

export default DeniedAccessModal
